let urlIncludesDisableFlag = window.location.search.includes('geo=false');
if (urlIncludesDisableFlag === false) geoRedirectPopupInit();

function geoRedirectPopupInit(){
  
  // Theme Editor Awareness
  var ThemeEditor = window.top.document.querySelector("#theme-editor");
  var isViewedInTE = ThemeEditor !== null ? ThemeEditor.matches('body#theme-editor') === true : false;
  
  // Cookie details
  var session_var_name = 'redirect-popup-opened';
  
  
  
  var cookie = {};

  cookie.name = 'redirect-popup-opened',
  cookie.value = false;
  cookie.expiration = 1;
  cookie.exists = readCookie( cookie.name ) != undefined && readCookie( cookie.name ) == false;
  
  
  
  function createCookie(name,value,days) {
    if (days) {
      var date = new Date();
      date.setTime(date.getTime()+(days*24*60*60*1000));
      var expires = "; expires="+date.toGMTString();
    }
    else var expires = "";
    document.cookie = name+"="+value+expires+"; path=/";
  }

  function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) == 0) return decodeURIComponent(c.substring(nameEQ.length,c.length));
    }
    return null;
  }
  
  function GetURLParameter(sParam) {

    var sPageURL = window.location.search.substring(1);
    var sURLVariables = sPageURL.split('&');

    for (var i = 0; i < sURLVariables.length; i++)
    {

      var sParameterName = sURLVariables[i].split('=');
      if (sParameterName[0] == sParam)
      {
        return sParameterName[1];
      }

    }

  }
  
  function getRefersionReferralID() {
   
    // Get referral ID OR false
    return GetURLParameter("rfsn") || false;
    
  }
  
  function getRefersionParam() {
    
    var refersionID = getRefersionReferralID(),
        refersionParam = "";
    
    if ( refersionID ){
      refersionParam = "rfsn=" + refersionID;
    }
    
    return refersionParam;
    
  }
  
  function requestGeoLocationAJAX( callback ) {
  
    var oReq = new XMLHttpRequest();

    oReq.addEventListener("readystatechange", onGeoLocationResponse );  
    oReq.open("GET", "https://telize-v1.p.rapidapi.com/location");
    oReq.setRequestHeader('x-rapidapi-host','telize-v1.p.rapidapi.com');
    oReq.setRequestHeader('x-rapidapi-key','a61f2d6aebmshea26202d6f1737ep194d13jsn41d1bf7648bc');
    oReq.setRequestHeader('Accept','application/json');
    oReq.send();

  }
  
  function getCustomerCountryCode( geoLocationResponse ) {
    return geoLocationResponse.country_code.toLowerCase();
  }

  function getCustomerCountryName( geoLocationResponse ) {
    return geoLocationResponse.country;
  }
  
  function getCurrentStoreShippingFromLocation() {
    return user_location_redirect_popup_obj.shipping_from.toLowerCase();
  }
  
  function getCurrentStoreShippingFromLocationLabel() {
    return user_location_redirect_popup_obj.shipping_from_label.toLowerCase();
  }
  
  function getCurrentStoreShippingToLocations() {
    return user_location_redirect_popup_obj.shipping_to.toLowerCase() || getCurrentStoreShippingFromLocation();  
  }
  
  function getCustomerLocation( response ){
    try {
      var jsonObj = JSON.parse(response.responseText);
    } catch (e) {
        return false;
    }
    return jsonObj;
  }
  
  // ADD: addURLPathToOtherStoreLinks
  
  function tackOnPathAndSearchToAllAlternativeStores() {
    
    // Get path and search query after '/' after domain
    var pathname = getURLPath();
    
    // Only add the pathname to the second flag up to the last flag
    $('#user-location-redirect-popup a').slice(1,-1).each(function(){
      
        $thisLink = $(this);
        current_href = $thisLink.attr("href");
        new_href = removeTrailingSlash( current_href ) + pathname;

        $thisLink.attr("href", new_href);
    
    }) 
  }
  
  function addRefersionParamToOtherStoreLinks(param) {
    $('.other-countries a').each(function(){
        
        $thisLink = $(this);
        current_href = $thisLink.attr("href");
        new_href = removeTrailingSlash( current_href ) + "/?" + param;

        $thisLink.attr("href", new_href);
    }) 
  }
  
  function removeTrailingSlash (url) {
    return url.replace(/\/$/,"");
  }
  
  function getURLPath() {
    return location.pathname + location.search;
  }
  
  function onGeoLocationResponse() {
    
    if (this.readyState === this.DONE) {
      
        var location = null,
            current_store_shipping_from = getCurrentStoreShippingFromLocation(),
            current_store_shipping_to_ctry_codes = getCurrentStoreShippingToLocations(),  // String
            geoLocationResponse = getCustomerLocation( this ),
            customer_location_ctry_code = getCustomerCountryCode( geoLocationResponse ),
            customer_location_ctry_name = getCustomerCountryName( geoLocationResponse ),
            customer_is_within_shipping_zone = current_store_shipping_to_ctry_codes.indexOf( customer_location_ctry_code ) != -1,
            $location_right = $('.location.region-matching');
            
            // COMMENTED OUT refersion param: NOW USING THE ENTIRE PATHNAME AND SEARCH 4/2/20
            // refersionParam = getRefersionParam();    
        
        console.log("current_store_shipping_from: ",current_store_shipping_from),
        console.log("current_store_shipping_to: ",current_store_shipping_to_ctry_codes),
        console.log("customer_is_within_shipping_zone:",customer_is_within_shipping_zone),
        console.log("customer_location_ctry_code: ",customer_location_ctry_code),
        console.log("customer_location_ctry_name: ",customer_location_ctry_name),
        console.log("Telize's Response:",geoLocationResponse);
        console.log("user_location_redirect_popup_obj:",user_location_redirect_popup_obj);
        
        // COMMENTED OUT refersion param: NOW USING THE ENTIRE PATHNAME AND SEARCH 4/2/20
        // console.log("refersionParam", refersionParam);
        
        
        // Update Main Object...
        user_location_redirect_popup_obj.customer.ctry_name = geoLocationResponse.country;
        user_location_redirect_popup_obj.customer.ctry_code = customer_location_ctry_code;
        user_location_redirect_popup_obj.customer.coordinates = { lat: geoLocationResponse.latitude, long: geoLocationResponse.longitude };
    
        /* LOGIC
          
            If VISITING customer's country code.. 
              A) IS WITHIN "Shipping" to country codes
                  -> Do Nothing
              B) IS OUTSIDE "Shiping to" country codes
                  -> Show Popup with alternative stores
                    
            NOTES:
            - Feb 4 2020:   The original user experience was to REMOVE 
                    the right flag and center the left flag
                      and MAY be used again in the future so the 
                            code remains for now
            - 7/1/2020	Added the ability to see the popup in the admin if viewed from within the country it not otherwise show
            
        */
      	
      
        if ( customer_is_within_shipping_zone && ! isViewedInTE )
        {
            user_location_redirect_popup_obj.customer.ctry_region_preferred_label = getCurrentStoreShippingFromLocationLabel();
            user_location_redirect_popup_obj.customer.ctry_region_preferred_code = current_store_shipping_from;
          
            // Dont Show Popup
            return;
          
          // Remove the right location 
            $location_right.remove();
            $('.locations-flags').addClass('centered');
        }  
        else 
        {
            // RIGHT SIDE ONLY
            alt_stores = user_location_redirect_popup_obj.shipping_locations;
          
            for( store in alt_stores )
            {
              var alt_store = alt_stores[store],
                  alt_store_url = alt_store.url;
        
              // COMMENTED OUT refersion param: NOW USING THE ENTIRE PATHNAME AND SEARCH 4/2/20
              /*
              if ( refersionParam.length )
              {
                  alt_store_url = removeTrailingSlash( alt_store_url ) + "/?" + refersionParam;
              }
              */
              
              // If customer's "country code alpha-2" is within THIS store's country "country codes"..
              customer_is_within_alternate_shipping_to_zone = alt_store.ships_to.indexOf( customer_location_ctry_code ) != -1
              
              if ( customer_is_within_alternate_shipping_to_zone )
              {
                
                user_location_redirect_popup_obj.customer.ctry_region_preferred_label = alt_store.ctry_name;
                user_location_redirect_popup_obj.customer.ctry_region_preferred_code = alt_store.ctry_code;
                                
                // Offer as a second choice the best alternative (right side)
                $location_right
                  .attr({'href': alt_store_url, "title": alt_store.ctry_name})
                    .children("img").attr('src', alt_store.flag_img).parent()
                    .children("span").text(alt_store.ctry_name);

                // Remove this location as an other country under "Other Countries"
                $('.other-countries [ctry_code=' + alt_store.ctry_code + ']').remove();
                console.log("$('.other-countries [ctry_code='" + alt_store.ctry_code + "']')");
                
                // Move all Regions (Store which ships to multiple places) to the end of the list
                $('.other-countries a').append('\n');
                $('.other-countries [is_region=true]').insertAfter('.other-countries > a:nth-last-of-type(1)');
              }

            }

            // Dont refresh the page if the FIRST location is clicked
            $('#user-location-redirect-popup .location').first().on("click",function(e){
              e.preventDefault();
              closePopup();
            });
        }
      
        // COMMENTED OUT refersion param: NOW USING THE ENTIRE PATHNAME AND SEARCH 4/2/20
        /*
        if ( refersionParam.length )
        {
          // Update links on the flags of OTHER COUNTRIES (BELOW MAIN COUNTRIES)
          addRefersionParamToOtherStoreLinks( refersionParam );
        }
        */
      
        tackOnPathAndSearchToAllAlternativeStores();
      
        displayPopup();
      
  }
    
  }
  
  function displayPopup() {
    $('#user-location-redirect-popup').popup('show');
  }
  
  function closePopup() {
    $('#user-location-redirect-popup').popup('hide');
  }
  
  function initPopup() {
    var popup_settings = {
      closeelement:'span.close',
      blur:false
    };
    
    // If Viewed inside the Theme Editor (Customizer)
    if( isViewedInTE ) {
      popup_settings.blur = true;
    }
    
    
    $('#user-location-redirect-popup').popup( popup_settings );
    $.fn.popup.defaults.pagecontainer = '#page';
  }
    
  (function($){
    $(function(){
      
      initPopup();
      
      
      //createCookie( cookie.name, cookie.value, cookie.expiration );
      $('#user-location-redirect-popup').on("click","a",function(){
          sessionStorage.setItem( session_var_name, true );
      });
      
      
      
      $('#store_country_picker').on("change", function(){
        if ( this.selectedIndex )
        {
          location.href = this.value + "?override=1";
        }
      })
      
      
      
      
      if ( sessionStorage.getItem( session_var_name ) == null )
      {
        requestGeoLocationAJAX();
      }
      
    });
    
  })(jQuery);
  
};